export default __webpack_public_path__ + "static/media/1022px-Vimlogo.svg.7f2bd845.png";